/* =========================================================
   LUCA CLAUDE — 23/09/2026 — FILE NUOVO
   Fumagalli — filtri collection (Search & Discovery)
   Caricato da snippets/fumagalli-filters.liquid.
   Nessun file originale del tema viene modificato da questo script:
   agisce solo sul DOM generato da slider-prezzo.liquid e
   collection-template.liquid.

   CONSEGNA 1 — cosa fa:
   1. Trasforma ogni filtro del form #CollectionFiltersForm in un
      gruppo a fisarmonica, chiuso di default (aperto se ha un
      filtro attivo o se l'utente l'aveva aperto).
   2. Numero di valori selezionati accanto al titolo del gruppo,
      es. "COLORE (1)", e il totale sul bottone "Filtro".
   3. "Mostra altri" nei gruppi con più di 8 voci.
   4. Chip dei filtri attivi in cima al pannello + "Cancella tutto",
      ripetute sopra la griglia prodotti.
   5. FIX: cambiare l'ordinamento non cancella più i filtri attivi.
   6. FIX: non invia il prezzo di default né il parametro view,
      e mantiene l'ordinamento scelto.

   CONSEGNA 2 — cosa fa:
   7. Filtri applicati subito al click, senza ricaricare la pagina:
      chiede a Shopify il template collection.ajax (già presente nel
      tema) e sostituisce SOLO griglia prodotti, valori/conteggi dei
      filtri, chip e "Carica altro". Il pannello resta aperto e i
      gruppi restano come li ha lasciati l'utente.
   8. Anche togliere un filtro (X sulla chip, "Cancella tutto",
      togliere la spunta) aggiorna senza ricaricare.
   9. Slider prezzo: applica quando si rilascia il cursore.
  10. URL aggiornato (link condivisibile), tasto indietro funzionante.
  11. Bottone in fondo al pannello: nascosto su desktop; su mobile
      diventa "Mostra N prodotti" e chiude il pannello.
  12. Se la richiesta AJAX fallisce → ricarica classica della pagina
      con i filtri scelti (nessun blocco per il cliente).
   ========================================================= */
(function () {
  'use strict';

  var FORM_ID = 'CollectionFiltersForm';
  var MAX_VISIBLE = 8;
  var STORE_KEY = 'fmgFiltersOpen';
  var DEBOUNCE_MS = 250;
  // LUCA CLAUDE — 23/09/2026 — chip sopra la griglia disattivate su richiesta
  // (restano solo nel pannello filtri). Rimettere true per riattivarle.
  var SHOW_TOP_CHIPS = false;
  // LUCA CLAUDE — 23/09/2026 — "Mostra altri" disattivato su richiesta:
  // con i gruppi chiusi l'elenco completo si vede solo aprendo il gruppo.
  // Rimettere true per riattivarlo (dopo MAX_VISIBLE voci).
  var SHOW_MORE_ENABLED = false;

  var isIT = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('it') === 0;
  var T = isIT
    ? { more: 'Mostra altri', less: 'Mostra meno', clear: 'Cancella tutto',
        show: function (n) { return 'Mostra ' + n + (n === 1 ? ' prodotto' : ' prodotti'); } }
    : { more: 'Show more', less: 'Show less', clear: 'Clear all',
        show: function (n) { return 'Show ' + n + (n === 1 ? ' product' : ' products'); } };

  var CHEVRON =
    '<svg class="fmg-group__chevron" viewBox="0 0 12 12" aria-hidden="true" focusable="false">' +
    '<path d="M1.5 4l4.5 4.5L10.5 4" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>';

  var state = { form: null, groups: [], timer: null, controller: null };

  /* ============ utilità ============ */
  function norm(t) { return (t || '').replace(/\s+/g, ' ').trim(); }

  function currentSort() {
    return new URLSearchParams(window.location.search).get('sort_by');
  }

  function cleanHref(href) {
    try {
      var u = new URL(href, window.location.origin);
      u.searchParams.delete('view');
      u.searchParams.delete('page');
      return u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '');
    } catch (e) { return href; }
  }

  function readOpen() {
    try { return JSON.parse(sessionStorage.getItem(STORE_KEY)) || []; } catch (e) { return []; }
  }
  function saveOpen() {
    try {
      var keys = [];
      state.form.querySelectorAll('.fmg-group.is-open').forEach(function (g) { keys.push(g.getAttribute('data-key')); });
      sessionStorage.setItem(STORE_KEY, JSON.stringify(keys));
    } catch (e) { /* storage non disponibile */ }
  }

  function isPriceActive(form) {
    var params = new URLSearchParams(window.location.search);
    var gte = params.get('filter.v.price.gte');
    var lte = params.get('filter.v.price.lte');
    if (gte === null && lte === null) return false;
    var maxInput = form.querySelector('input[name="filter.v.price.lte"]');
    var maxAttr = maxInput ? parseFloat(maxInput.getAttribute('max')) : NaN;
    var minActive = gte !== null && parseFloat(gte) > 0;
    var maxActive = lte !== null && !isNaN(maxAttr) && parseFloat(lte) < maxAttr;
    return minActive || maxActive;
  }

  /* ============ parametri da inviare (punto 6) ============ */
  function buildParams(form) {
    var params = new URLSearchParams();
    var min = form.querySelector('input[name="filter.v.price.gte"]');
    var max = form.querySelector('input[name="filter.v.price.lte"]');
    var skipPrice = false;
    if (min && max) {
      var maxAttr = parseFloat(max.getAttribute('max'));
      var minDefault = !(parseFloat(min.value) > 0);
      var maxDefault = isNaN(maxAttr) || !(parseFloat(max.value) < maxAttr);
      skipPrice = minDefault && maxDefault;
    }
    new FormData(form).forEach(function (value, name) {
      if (name === 'view' || name === 'sort_by') return;
      if (skipPrice && name.indexOf('filter.v.price') === 0) return;
      if (name.indexOf('filter.') !== 0) return;
      params.append(name, value);
    });
    var sort = currentSort();
    if (sort) params.set('sort_by', sort);
    return params;
  }

  function urlFromParams(params) {
    var q = params.toString();
    return window.location.pathname + (q ? '?' + q : '');
  }

  /* ============ gruppi (punti 1-3) ============ */
  function makeGroup(titleEl, index) {
    var label = norm(titleEl ? titleEl.textContent : '');
    var bodyId = 'FmgGroupBody-' + index;

    var root = document.createElement('div');
    root.className = 'fmg-group';
    root.setAttribute('data-key', label);

    var header = document.createElement('button');
    header.type = 'button';
    header.className = 'fmg-group__header';
    header.setAttribute('aria-expanded', 'false');
    header.setAttribute('aria-controls', bodyId);

    var title = document.createElement('span');
    title.className = 'fmg-group__title';
    var titleText = document.createElement('span');
    titleText.textContent = label;
    var titleCount = document.createElement('span');
    titleCount.className = 'fmg-group__title-count';
    title.appendChild(titleText);
    title.appendChild(titleCount);
    header.appendChild(title);
    header.insertAdjacentHTML('beforeend', CHEVRON);

    var body = document.createElement('div');
    body.className = 'fmg-group__body';
    body.id = bodyId;

    root.appendChild(header);
    root.appendChild(body);

    return { key: label, root: root, header: header, body: body, countEl: titleCount, count: 0, ul: null, isPrice: false };
  }

  function setOpen(group, open) {
    group.root.classList.toggle('is-open', open);
    group.header.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function setCount(group) {
    if (group.isPrice) {
      group.count = isPriceActive(state.form) ? 1 : 0;
    } else if (group.ul) {
      group.count = group.ul.querySelectorAll('input[type="checkbox"]:checked').length;
    }
    group.countEl.textContent = group.count > 0 ? '(' + group.count + ')' : '';
  }

  function addShowMore(group) {
    var ul = group.ul;
    var old = group.body.querySelector('.fmg-more');
    if (old) old.remove();

    var items = Array.prototype.slice.call(ul.children);
    if (!SHOW_MORE_ENABLED || items.length <= MAX_VISIBLE) {
      items.forEach(function (li) { li.classList.remove('fmg-extra'); });
      return;
    }

    var hidden = items.length - MAX_VISIBLE;
    var hiddenChecked = false;
    items.forEach(function (li, i) {
      li.classList.toggle('fmg-extra', i >= MAX_VISIBLE);
      if (i >= MAX_VISIBLE && li.querySelector('input:checked')) hiddenChecked = true;
    });
    if (hiddenChecked) group.root.classList.add('is-expanded');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fmg-more';
    var label = function () {
      return group.root.classList.contains('is-expanded') ? T.less : T.more + ' (' + hidden + ')';
    };
    btn.textContent = label();
    btn.addEventListener('click', function () {
      group.root.classList.toggle('is-expanded');
      btn.textContent = label();
    });
    ul.parentNode.insertBefore(btn, ul.nextSibling);
  }

  function buildGroups(form) {
    var groups = [];
    Array.prototype.slice.call(form.children).forEach(function (el) {
      var group;
      if (el.classList.contains('widget-title')) {
        var ul = el.nextElementSibling;
        if (!ul || !ul.matches('ul.filter-group-display__list')) return;
        group = makeGroup(el, groups.length);
        form.insertBefore(group.root, el);
        group.body.appendChild(el);
        group.body.appendChild(ul);
        group.ul = ul;
        addShowMore(group);
        groups.push(group);
        return;
      }
      if (el.classList.contains('filter-group-display__price-range')) {
        group = makeGroup(el.querySelector('.widget-title'), groups.length);
        form.insertBefore(group.root, el);
        group.body.appendChild(el);
        group.isPrice = true;
        groups.push(group);
      }
    });

    var saved = readOpen();
    groups.forEach(function (g) {
      setCount(g);
      setOpen(g, g.count > 0 || saved.indexOf(g.key) !== -1);
      g.header.addEventListener('click', function () {
        setOpen(g, !g.root.classList.contains('is-open'));
        saveOpen();
      });
    });
    return groups;
  }

  /* ============ chip (punto 4) ============ */
  function makeClearAll() {
    var a = document.createElement('a');
    a.className = 'fmg-clear-all';
    var sort = currentSort();
    a.href = window.location.pathname + (sort ? '?sort_by=' + encodeURIComponent(sort) : '');
    a.textContent = T.clear;
    return a;
  }

  function renderChips(chipNodes) {
    var box = state.form.querySelector('.fmg-active');
    if (box) {
      box.innerHTML = '';
      chipNodes.forEach(function (c) {
        var n = c.cloneNode(true);
        n.setAttribute('href', cleanHref(n.getAttribute('href')));
        box.appendChild(n);
      });
      if (chipNodes.length) box.appendChild(makeClearAll());
      box.style.display = chipNodes.length ? '' : 'none';
    }

    var top = document.querySelector('.fmg-chips');
    var grid = document.querySelector('.grid-container-items');
    if (!SHOW_TOP_CHIPS || !chipNodes.length) { if (top) top.remove(); return; }
    if (!top && grid) {
      top = document.createElement('div');
      top.className = 'fmg-chips';
      grid.parentNode.insertBefore(top, grid);
    }
    if (!top) return;
    top.innerHTML = '';
    chipNodes.forEach(function (c) {
      var n = c.cloneNode(true);
      n.setAttribute('href', cleanHref(n.getAttribute('href')));
      top.appendChild(n);
    });
    top.appendChild(makeClearAll());
  }

  function initChips(form) {
    var box = form.querySelector('.active-filters');
    if (!box) return;
    var chips = Array.prototype.slice.call(box.querySelectorAll('a.active-filters__remove-filter'));
    box.classList.add('fmg-active');
    form.insertBefore(box, form.firstChild);
    renderChips(chips);
  }

  /* ============ contatori ============ */
  function updateFilterButton() {
    var total = state.groups.reduce(function (s, g) { return s + g.count; }, 0);
    document.querySelectorAll('.js-drawer-open-collection-filters').forEach(function (btn) {
      var span = btn.querySelector('.fmg-btn-count');
      btn.classList.toggle('btn--tertiary-active', total > 0);
      if (!total) { if (span) span.remove(); return; }
      if (!span) {
        span = document.createElement('span');
        span.className = 'fmg-btn-count';
        btn.appendChild(span);
      }
      span.textContent = '(' + total + ')';
    });
  }

  function updateShowButton(count) {
    var input = state.form.querySelector('.filtri-fumagalli input[type="submit"]');
    if (!input) return;
    if (typeof count === 'number' && !isNaN(count)) input.value = T.show(count);
  }

  /* ============ AJAX (punti 7-12) ============ */
  function setLoading(on) {
    var grid = document.querySelector('.grid-container-items');
    if (grid) grid.classList.toggle('fmg-loading', on);
    state.form.classList.toggle('fmg-loading', on);
  }

  function schedule() {
    if (state.controller) state.controller.abort();
    clearTimeout(state.timer);
    state.timer = setTimeout(function () {
      applyUrl(urlFromParams(buildParams(state.form)));
    }, DEBOUNCE_MS);
  }

  function applyUrl(url) {
    if (state.controller) state.controller.abort();
    var controller = window.AbortController ? new AbortController() : null;
    state.controller = controller;

    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'view=ajax';
    setLoading(true);

    fetch(fetchUrl, { credentials: 'same-origin', signal: controller ? controller.signal : undefined })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        if (controller && controller.signal.aborted) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (!doc.querySelector('.grid-container-items') || !doc.getElementById(FORM_ID)) {
          throw new Error('risposta inattesa');
        }
        // LUCA CLAUDE — 24/09/2026 — swap() restituisce false se servono gruppi nuovi: ricarica classica
        if (swap(doc) === false) { window.location.href = url; return; }
        history.pushState({ fmg: true }, '', url);
        setLoading(false);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        // punto 12: in caso di problemi, ricarica classica
        window.location.href = url;
      });
  }

  function swap(doc) {
    // griglia prodotti
    var grid = document.querySelector('.grid-container-items');
    var newGrid = doc.querySelector('.grid-container-items');
    grid.innerHTML = newGrid.innerHTML;

    // valori dei filtri (conteggi, voci disabilitate) — gruppo per gruppo
    var newForm = doc.getElementById(FORM_ID);
    var fresh = {};
    newForm.querySelectorAll('.widget-title').forEach(function (t) {
      var ul = t.nextElementSibling;
      if (ul && ul.matches('ul.filter-group-display__list')) fresh[norm(t.textContent)] = ul;
    });
    // LUCA CLAUDE — 24/09/2026 — FIX gruppi "fantasma"
    // Shopify NON restituisce un gruppo di filtri quando, con i filtri già
    // scelti, nessun prodotto avrebbe quei valori (es. MEASUREMENTS sparisce
    // dopo aver scelto certe VARIANTS). Prima il gruppo restava a video con
    // i valori vecchi: cliccandoli si arrivava a 0 prodotti.
    // Ora: gruppo assente nella risposta = nascosto e svuotato;
    // gruppo nuovo che prima non c'era = ricarica classica della pagina.
    var known = {};
    state.groups.forEach(function (g) { known[g.key] = true; });
    for (var k in fresh) {
      if (Object.prototype.hasOwnProperty.call(fresh, k) && !known[k]) return false;
    }
    state.groups.forEach(function (g) {
      if (g.ul) {
        if (fresh[g.key]) {
          g.ul.innerHTML = fresh[g.key].innerHTML;
          g.root.style.display = '';
        } else {
          g.ul.innerHTML = '';
          g.root.style.display = 'none';
        }
        addShowMore(g);
      }
      setCount(g);
    });
    // LUCA CLAUDE — FINE fix gruppi fantasma

    // chip
    var newChips = Array.prototype.slice.call(newForm.querySelectorAll('.active-filters a.active-filters__remove-filter'));
    renderChips(newChips);

    // "Carica altro"
    swapLoadMore(doc);

    // contatori
    updateFilterButton();
    var data = doc.getElementById('FmgFiltersData');
    var count = data ? parseInt(data.getAttribute('data-products-count'), 10) : NaN;
    updateShowButton(count);

    // riattiva ciò che il tema fa sui prodotti (AOS, valute, recensioni)
    try { if (window.theme && theme.reinitProductGridItem) theme.reinitProductGridItem(); } catch (e) { /* ignore */ }
  }

  function swapLoadMore(doc) {
    var oldW = document.getElementById('load-more-wrapper');
    var newW = doc.getElementById('load-more-wrapper');
    var grid = document.querySelector('.grid-container-items');

    // il totale per lo script infinite-scroll del tema
    var data = doc.getElementById('FmgFiltersData');
    if (data) window.totalProductCount = parseInt(data.getAttribute('data-products-count'), 10);
    if (typeof window.isSearch === 'undefined') window.isSearch = false;

    if (!newW) { if (oldW) oldW.remove(); return; }
    var clone = document.importNode(newW, true);
    if (oldW) {
      oldW.parentNode.replaceChild(clone, oldW);
    } else if (grid) {
      grid.parentNode.insertBefore(clone, grid.nextSibling);
    }

    // se la pagina era partita senza "Carica altro", lo script non è caricato
    if (typeof window.initInfiniteScroll !== 'function') {
      var s = doc.querySelector('script[src*="infinite-scroll"]');
      if (s) {
        var tag = document.createElement('script');
        tag.src = s.getAttribute('src');
        document.body.appendChild(tag);
      }
    }
  }

  function bindAjax(form) {
    // spunte
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name || t.name.indexOf('filter.') !== 0) return;
      schedule();
    });

    // slider prezzo: il tema usa jQuery .trigger('change'), che non
    // arriva agli ascoltatori nativi → ci agganciamo anche via jQuery
    if (window.jQuery) {
      window.jQuery(form).on('change.fmg', 'input[name^="filter.v.price"]', function () { schedule(); });
    }

    // invio del form (Invio sulla tastiera, bottone)
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (window.matchMedia('(max-width: 768px)').matches) {
        closeDrawer();
        return;
      }
      schedule();
    });

    // chip e "Cancella tutto", sia nel pannello sia sopra la griglia
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.fmg-active a, .fmg-chips a');
      if (!a) return;
      e.preventDefault();
      var url = cleanHref(a.getAttribute('href'));
      var u = new URL(url, window.location.origin);
      // allinea spunte e prezzo del form allo stato del link
      state.form.querySelectorAll('input[type="checkbox"][name^="filter."]').forEach(function (cb) {
        cb.checked = u.searchParams.getAll(cb.name).indexOf(cb.value) !== -1;
      });
      if (!u.searchParams.has('filter.v.price.gte') && !u.searchParams.has('filter.v.price.lte')) {
        resetPrice();
      }
      applyUrl(url);
    });

    // tasto indietro/avanti: ricarichiamo la pagina corrispondente
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.fmg) window.location.reload();
    });
    history.replaceState({ fmg: true }, '', window.location.href);
  }

  function resetPrice() {
    var min = state.form.querySelector('input[name="filter.v.price.gte"]');
    var max = state.form.querySelector('input[name="filter.v.price.lte"]');
    if (min) min.value = 0;
    if (max && max.getAttribute('max')) max.value = max.getAttribute('max');
    try {
      var $r = window.jQuery && window.jQuery(state.form).find('.range-slider');
      if ($r && $r.length && $r.jRange) $r.jRange('setValue', '0,' + (max ? max.value : ''));
    } catch (e) { /* slider non ancora pronto */ }
  }

  function closeDrawer() {
    if (window.theme && theme.FilterDrawer && theme.FilterDrawer.close) {
      theme.FilterDrawer.close();
    }
    var grid = document.querySelector('.grid-container-items');
    if (grid) {
      var y = grid.getBoundingClientRect().top + window.pageYOffset - 140;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }
  }

  /* ============ ordinamento che mantiene i filtri (punto 5) ============ */
  // "capture": parte prima dell'handler di theme.js (che perderebbe i filtri)
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.id !== 'SortBy') return;
    e.stopImmediatePropagation();
    e.stopPropagation();
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', t.value);
    params.delete('page');
    params.delete('view');
    window.location.href = window.location.pathname + '?' + params.toString();
  }, true);

  /* ============ avvio ============ */
  function init() {
    var form = document.getElementById(FORM_ID);
    if (!form || form.getAttribute('data-fmg-init')) return;
    form.setAttribute('data-fmg-init', '1');
    state.form = form;

    state.groups = buildGroups(form);
    initChips(form);
    updateFilterButton();

    var data = document.getElementById('FmgFiltersData');
    updateShowButton(data ? parseInt(data.getAttribute('data-products-count'), 10) : NaN);

    if (window.fetch && window.DOMParser && window.history && history.pushState) {
      bindAjax(form);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
